import { createRouter, createWebHistory } from 'vue-router'
import ChatView from '../views/ChatView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/chat/:param(.*)', // 使用 (.*) 來匹配所有字符
      name: 'chat',
      component: ChatView,
      props: true
    }
  ]
})

export default router
